module.exports = __webpack_public_path__ + "ca39403f9d6ee58f21d5e4f9d38c6ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header_mail.png
// module id = 45
// module chunks = 0 1 2 3 4